var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34175",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45418 4.56747C11.1601 3.57628 13.2569 3.5936 14.9467 4.61285C16.62 5.65285 17.637 7.50896 17.6275 9.5056C17.5885 11.4892 16.4981 13.3537 15.135 14.7951C14.3482 15.6307 13.4681 16.3697 12.5126 16.9968C12.4142 17.0537 12.3064 17.0918 12.1946 17.1092C12.0869 17.1046 11.9821 17.0728 11.8895 17.0166C10.4308 16.0743 9.15101 14.8715 8.1118 13.4661C7.24222 12.2929 6.74818 10.8755 6.69678 9.40643C6.69565 7.40595 7.7483 5.55866 9.45418 4.56747ZM10.4402 10.2344C10.7272 10.9419 11.4045 11.4033 12.1559 11.4033C12.6482 11.4069 13.1214 11.2097 13.4701 10.8557C13.8188 10.5017 14.0141 10.0204 14.0123 9.51895C14.0149 8.75352 13.5643 8.06197 12.8708 7.7672C12.1774 7.47243 11.3778 7.63258 10.8455 8.17287C10.3133 8.71316 10.1533 9.52702 10.4402 10.2344Z",
    fill: "#BED8F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea);
export default __webpack_public_path__ + "static/media/area.b2291afea06a47938961c077d4d4d586.svg";
export { ForwardRef as ReactComponent };